module.exports = __webpack_public_path__ + "static/media/bbraun_logo_green.56398f7b.svg";